import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

console.log('[React] Starting render');

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Add class to body to remove loading styles and make text visible
document.body.classList.add('react-loaded');

console.log('[React] Render complete');
